module.exports = __webpack_public_path__ + "static/media/major_group.598542b4.svg";